import React, { ReactNode } from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'
import { Button, Page } from '../../../components'
import { AuthenticatedRoutable } from '../../../models'
import { urls } from '../../../routing'
import literalsService from '../../../services/literals-service'
import StyledArticle from './styles'
import { appsStyleSelected } from '../../../helpers/app'

interface IProps extends RouteComponentProps {
  dispatch: any
}

/** Shown once a suggestion, complaint or lost object report has been sent. */
class ComplaintsAndSuggestionsDone extends AuthenticatedRoutable<IProps> {
  // Material "task alt": a ring with the tick running out of it, in the brand colour.
  private get checkIcon(): ReactNode {
    return (
      <svg className="check" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M22 5.18 10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10L22 5.18zM19.79 10.22c.14.57.21 1.17.21 1.78 0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8c1.58 0 3.04.46 4.28 1.25l1.44-1.44C16.1 2.67 14.13 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-1.19-.22-2.33-.6-3.39l-1.61 1.61z" />
      </svg>
    )
  }

  public render(): ReactNode {
    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            { this.checkIcon }
            <h3>{ literalsService.get('thanksForYourMessage', true) }</h3>
            <p>{ literalsService.get('weWillReviewItSoon', true) }</p>
            <Button
              title={ literalsService.get('accept', true) }
              onPress={ this.goToConfiguration }
              className="acceptButton"
              filled
              upper
            />
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  private goToConfiguration = () => {
    this.props.history.push(urls.config)
  }
}

export default withRouter(connect()(ComplaintsAndSuggestionsDone))
